import { isLayout, isMobile, isTablet } from 'components/Shared/responsive';
import styles from './stylesLogo.scss';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { SmallLogoECP } from './smallLogoECP';

interface OwnProps {
  className?: string;
}

export const Logo = ({ className }: OwnProps) => {
  const showSmallLogo = useSelector(isLayout(isMobile, isTablet));

  return (
    <a
      className={cn(className, {
        [styles.smallLogo]: showSmallLogo
      })}
      href="/"
    >
      <SmallLogoECP />
    </a>
  );
};
